import { IOfferCard } from '../../../../types';

export const prepareQualityInfo = ({ offerUser }: IOfferCard) => ({
  isSuperAgent: !!offerUser?.agentModerationInfo?.qualityLevelInfo?.showSuperAgent,
  isSuperHost: !!offerUser?.agentModerationInfo?.qualityLevelInfo?.showSuperHost,
});
